module.exports = __webpack_public_path__ + "static/media/wallmart.692cb57c.jpg";